import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { motion } from "framer-motion";

import logo from "assets/logos/logo.png";

const LoadingScreen = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="background.default"
    >
      {/* Logo */}
      <motion.img
        src={logo} // Replace with your logo path
        alt="Logo"
        width={128} // Adjust size as needed
        height={128} // Adjust size as needed
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        style={{ marginBottom: "16px" }}
      />

      {/* Circular Progress Indicator */}
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
      >
        <CircularProgress size={40} color="black" />
      </motion.div>

      {/* Optionally add a loading text */}
      <Typography variant="h6" sx={{ mt: 2 }}>
        Loading...
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
